<template>
  <div class="form-group bg-light-2 p-4 shadow-lg mt-5">
    <h4>¿Donde se venderá tu {{ kind }}?</h4>
    <hr />
    <div class="row">
      <div class="col-md-6 col-12">
        <span>Selecciona el alcance de tu publicacion</span>
        <select
          class="form-control"
          :value="typePlace"
          @change="handleChangeTypePlace"
        >
          <option value="GLOBAL">Vender de forma global</option>
          <option value="COUNTRIES">Vender en un lista de paises</option>
          <option value="CITY">Vender solo en una ciudad</option>
        </select>
        <!-- Select list of Country -->
        <div class="mt-5" v-if="typePlace == 'COUNTRIES'">
          <div>
            <label>Nombre del pais</label>
            <select class="form-control mt-2" @change="handleListCountries">
              <option value="-1">Selecciona un pais</option>
              <option
                v-for="country in countries"
                :key="country.iso3"
                :value="country.iso3"
              >
                {{ country ? country.nombre : "NOT_A_COUNTRY" }}
              </option>
            </select>
            <div class="form-inline pt-3">
              <div class="mx-sm-3 mb-2 pt-2">
                <span
                  class="badge badge-dark mr-1 p-2"
                  v-for="(country, i) in sellerPlaces"
                  :key="`optionInSpec[${i}]`"
                  >{{ country }}</span
                >
              </div>
              <span
                class="btn btn-warning ml-2"
                @click="handleDeleteCountries"
                v-if="sellerPlaces.length"
                >Borrar paises seleccionados</span
              >
            </div>
          </div>
        </div>

        <!-- Select City -->

        <div class="mt-5" v-if="typePlace == 'CITY'">
          <label>Nombre del pais</label>
          <select class="form-control" @change="handleSetCountry">
            <option
              v-for="country in countries"
              :key="country.iso3"
              :value="country.iso3"
            >
              {{ country.nombre }}
            </option>
          </select>
          <label class="mt-3">Nombre de la ciudad</label>
          <input
            type="text"
            class="form-control"
            :value="CityOfSale"
            placeholder="Nombre de la ciudad"
            @change="handleSetCityOfSale"
          />
        </div>
      </div>
      <div class="col-md-6" v-if="kind == 'producto'">
        <span>Detalles del envio</span
        ><select
          class="form-control"
          :value="shippingType"
          @change="handleChangeShippingType"
        >
          <option value="3">Costo de envío fijo</option>
          <option value="4">Costo de envío acordado con el comprador</option>
        </select>
        <div v-show="shippingType == 0 || shippingType == 3">
          <label class="mt-3">Costo de envío (${{ currency }})</label>
          <input
            type="number"
            placeholder="Costo de envío"
            class="form-control"
            :value="shippingPrice"
            @keyup="handleChangeShippingPrice"
          />
        </div>
        <div v-show="shippingType == 0 || shippingType == 3">
          <label class="mt-3">Costo de envío final ($SC)</label>
          <input
            type="number"
            placeholder="Costo de envío en Sacoin"
            class="form-control"
            :value="publishedShippingPrice"
            disabled
          />
        </div>
        <div v-show="shippingType == 1">
          <label class="mt-3">Envio Nacional</label>
          <input
            type="text"
            class="form-control"
            placeholder="15 $SC"
            disabled
          />
          <label class="mt-3">Envio a de Ciudad de México</label>
          <input
            type="text"
            class="form-control"
            value="12 $SC"
            placeholder="12 $SC"
            disabled
          />
          <p class="mt-2">
            Sistema apple le enviara la guía y se la descontara de su saldo.
          </p>
        </div>
        <div v-show="shippingType == 2">
          <label class="mt-3">Dirección</label>
          <input
            type="text"
            class="form-control"
            placeholder="Dirección"
            :value="pickUp.address"
            @change="handleChangpickUpAddress"
          />
          <label class="mt-3">Teléfono</label>
          <input
            type="text"
            class="form-control"
            placeholder="Teléfono"
            :value="pickUp.phone"
            @change="handleChangpickUpPhone"
          />
          <label class="mt-3">Horario disponible</label>
          <input
            type="text"
            class="form-control"
            placeholder="Horario disponible"
            :value="pickUp.date"
            @change="handleChangpickUpDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import countries from "@/configs/countries.js";
import { LC } from "../../tools/exchange";

export default {
  name: "SellerPlacePublication",
  props: {
    kind: {
      type: String,
      default: "producto",
    },
    sellerPlaceWorld: {
      type: Boolean,
      default: false,
    },
    sellerPlaces: {
      type: Array,
      default: () => [],
    },
    CityOfSale: {
      type: String,
      default: "",
    },
    shippingPrice: {
      type: Number,
      default: 0,
    },
    shippingType: {
      type: Number,
      default: 4,
    },
    currency: {
      type: String,
      default: "",
    },
    pickUp: {
      type: Object,
      default: () => {
        return {
          phone: "",
          date: "",
          address: "",
        };
      },
    },
  },
  data() {
    return {
      countries: [],
      listCountriesSelected: [],
      localCurrency: null,
    };
  },
  created() {
    this.countries = countries;
    LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
  },
  methods: {
    handleChangpickUpAddress(e) {
      this.$emit("handleChangpickUpAddress", e.target.value);
    },
    handleChangpickUpPhone(e) {
      this.$emit("handleChangpickUpPhone", e.target.value);
    },
    handleChangpickUpDate(e) {
      this.$emit("handleChangpickUpDate", e.target.value);
    },
    handleChangeShippingPrice(e) {
      this.$emit("handleChangeShippingPrice", Number(e.target.value));
    },
    handleChangeShippingType(e) {
      this.$emit("handleChangeShippingType", Number(e.target.value));
    },
    handleSetCityOfSale(e) {
      return this.$emit("handleChangeTypePlace", {
        sellerPlaceWorld: false,
        sellerPlaces: this.sellerPlaces,
        CityOfSale: e.target.value,
      });
    },
    handleSetCountry(e) {
      if (e.target.value == "-1") return;
      return this.$emit("handleChangeTypePlace", {
        sellerPlaceWorld: false,
        sellerPlaces: [e.target.value],
        CityOfSale: this.CityOfSale,
      });
    },
    handleDeleteCountries() {
      return this.$emit("handleChangeTypePlace", {
        sellerPlaceWorld: false,
        sellerPlaces: [],
        CityOfSale: "",
      });
    },
    handleListCountries(e) {
      if (Number(e.target.value) == -1) return;
      if (this.sellerPlaces.includes(e.target.value)) return;
      this.sellerPlaces.push(e.target.value);
    },
    handleChangeTypePlace(e) {
      if (e.target.value == "GLOBAL") {
        return this.$emit("handleChangeTypePlace", {
          sellerPlaceWorld: true,
          sellerPlaces: [],
          CityOfSale: "",
        });
      }

      if (e.target.value == "COUNTRIES") {
        return this.$emit("handleChangeTypePlace", {
          sellerPlaceWorld: false,
          sellerPlaces: [],
          CityOfSale: "",
        });
      }

      return this.$emit("handleChangeTypePlace", {
        sellerPlaceWorld: false,
        sellerPlaces: [],
        CityOfSale: " ",
      });
    },
  },
  computed: {
    typePlace() {
      if (this.sellerPlaceWorld) return "GLOBAL";
      if (this.CityOfSale.length != " ") return "CITY";
      return "COUNTRIES";
    },
    publishedShippingPrice() {
      if (this.localCurrency)
        return this.localCurrency
          .localToSC({ price: this.shippingPrice, currency: this.currency })
          .toFixed(2);
      return 0;
    }
  },
};
</script>